import React, { Component } from 'react'
import { Button } from 'react-bootstrap'
import S from 'shorti'
import _ from 'lodash'
import controller from '../../controller'
const { NODE_ENV, BUILDING } = process.env
class Store extends Component {
  constructor() {
    super()
    this.state = {
      data: {}
    }
  }
  componentDidMount() {
    controller.getUser(this)
    if (this.props.location)
      controller.getWebsites(this, this.props.location.query.access_token)
  }
  getAsset(asset) {
    let image
    image = (NODE_ENV === 'development' || BUILDING === 'true') ?
      require('./images/' + asset) :
      '/images/' + asset
    return image
  }
  goToWebsite(website, mls_number) {
    let access_token
    if (this.props.location)
      access_token = this.props.location.query.access_token
    if (website)
      this.props.router.push(`/?access_token=${access_token}&website=${website}`)
    if (mls_number)
      this.props.router.push(`/?access_token=${access_token}&listing=${mls_number}`)
  }
  goToTemplates(type) {
    let access_token
    if (this.props.location)
      access_token = this.props.location.query.access_token
    this.props.router.push(`/?access_token=${access_token}&template_type=${type}`)
  }
  filterWebsites(type) {
    const data = this.state.data
    const websites = data.websites
    if (websites) {
      websites.forEach(website => {
        delete website.is_hidden // reset
        if (type === 'listing' && website.template === 'light')
          website.is_hidden = true
        if (type === 'agent' && website.template !== 'light')
          website.is_hidden = true
      })
    }
    data.websites_showing = type
    this.setState({
      data: {
        ...data,
        websites
      }
    })
  }
  visibleWebsitesCount() {
    const data = this.state.data
    const websites = data.websites
    let count = 0
    if (!websites || !websites.length)
      return count
    websites.forEach(website => {
      if (!website.is_hidden) {
        count++
      }
    })
    return count
  }
  render(){
    const data = this.state.data
    if (!data.websites_showing)
      data.websites_showing = 'agent'
    const header_style = {
      ...S('w-100p h-70 fw-500 font-21 pt-20 pl-30 fixed bg-fff z-2'),
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 0 rgba(0, 0, 0, 0.05)'
    }
    const containerStyle=
    !this.visibleWebsitesCount()
      ? {...S('absolute bg-f6f6f6 p-40 z-0 w-100p'), height: 'calc(100% - 70px)', display: 'flex', alignItems: 'center', justifyContent: 'center'}
      :  {...S(' bg-f6f6f6 p-40 z-0 w-100p'), height: 'calc(100% - 70px)', paddingLeft: '380px'}
    return (
      <div style={ S('bg-fff h-100p absolute w-100p') }>
        <div style={ header_style } className="sf">
          Your Templates
          <Button onClick={ this.goToTemplates.bind(this, data.websites_showing) } style={ S('bg-2196f3 color-fff border-none pull-right w-260 h-42 font-16 absolute t-15 z-0 r-10') }>
            Create { data.websites_showing === 'agent' ? 'agent' : 'listing' } website<img role="presentation" style={ S('w-15 mt-3n ml-22') } src={ this.getAsset('arrow@3x.png') } />
          </Button>
        </div>
        <div style={ S('pt-70') }>
          <div style={ {...S('fixed w-270 h-300 p-30 z-1 bg-fff'), height: 'calc(100% - 70px)'}}>
            <div style={ S(`mb-10 font-17 color-8696a4 pointer ${data.websites_showing === 'agent' ? 'color-2196f3' : ''}`) } onClick={ this.filterWebsites.bind(this, 'agent')}>Agent Websites ({ data.websites && _.filter(data.websites, { template: 'light' }) ? _.filter(data.websites, { template: 'light' }).length : 0 })</div>
            <div style={ S(`mb-10 font-17 color-8696a4 pointer ${data.websites_showing === 'listing' ? 'color-2196f3' : ''}`) } onClick={ this.filterWebsites.bind(this, 'listing')}>Listing Websites ({ data.websites && _.filter(data.websites, { template: 'clean' }) ? _.filter(data.websites, { template: 'clean' }).length : 0 })</div>
            <div style={ S('mb-10 font-17 color-8696a4 pointer') }>Flyers (0)</div>
          </div>
          <div style={containerStyle}>
            {
              data.websites &&
              data.websites.map(website => {
                if (website.is_hidden)
                  return <div></div>
                const card_style = { ...S('w-270 h-340 pull-left mr-40 border-1-solid-e2e6ea br-4 mb-40 relative pointer bg-fff'), overflow: 'hidden' }
                return (
                  <div onClick={ this.goToWebsite.bind(this, website.id, null) } key={ website.id } style={ card_style }>
                    <div style={ S('p-10 text-right border-bottom-1-solid-e2e6ea') }>
                      <a href={`http://${website.hostnames ? website.hostnames[0] : ''}`} target="_blank" style={ S('color-8696a4') }>{ website.hostnames ? website.hostnames[0] : '' }&nbsp;&nbsp;<i className="fa fa-external-link"></i></a>
                    </div>
                    <div style={ S('p-10') }>
                      <div style={ S(`w-100p h-100 bg-url(${website.attributes.cover_image}) bg-cover bg-center`) }/>
                    </div>
                    <div>
                      <div style={ S('text-left mb-20 p-20 color-263445 font-31') }>
                        { website.attributes.tagline }
                      </div>
                      <div style={ S('p-10 absolute b-0 w-100p') }>
                        <Button style={ S('border-1-solid-2196f3 color-2196f3 w-100p') }>Edit Website</Button>
                      </div>
                    </div>
                  </div>
                )
              })
            }
            {
              data.websites_loaded && !this.visibleWebsitesCount() &&
              <div style={ S(`text-center mt-140n`) }>
                { data.websites_showing === 'agent' &&
                  <img role="presentation" style={ S('w-683') } src={ this.getAsset('agent-website@3x.png') } />
                }
                { data.websites_showing === 'listing' &&
                  <img role="presentation" style={ S('w-683') } src={ this.getAsset('listing-graphic@3x.png') } />
                }
                <div>
                  <div style={ S('mb-20 color-9b9b9b') }>
                    <div style={ S('font-26 mb-20') }>You don't have any { data.websites_showing } websites</div>
                    <div style={ S('font-16 fw-300') }>{ data.websites_showing === 'agent' ? 'Agent' : 'Listing' } websites you create will appear here.</div>
                    <div style={ S('font-16 fw-300') }>You can edit and view your website.</div>
                  </div>
                  <Button onClick={ this.goToTemplates.bind(this, data.websites_showing) } className="btn btn-primary" style={ S('bg-2196f3 border-none w-260 h-42 font-17') }>Create { data.websites_showing } website<img role="presentation" style={ S('w-15 mt-3n ml-22') } src={ this.getAsset('arrow@3x.png') } /></Button>
                </div>
              </div>
            }
            <div className="clearfix"></div>
            {
              !data.websites_loaded &&
              <div style={ S(`font-22 fw-400 text-center `) }><i className="fa fa-spinner fa-pulse fa-2x text-primary"></i></div>
            }
          </div>
        </div>
      </div>
    )
  }
}
export default Store


// WEBPACK FOOTER //
// ./src/components/Store/index.js